import React from "react";
import { useTranslation } from "react-i18next";
import Constant from "../../constraints/constant.json";
import { LegalList, LegalPage, LegalSection, legalLinkClass } from "../PrivacyPolicy/LegalLayout";

export function TermCondition() {
  const { t } = useTranslation();

  const toc = [
    { id: "tc-use", label: t("page.term.Use") },
    { id: "tc-membership", label: t("page.term.Membership") },
    { id: "tc-registration", label: t("page.term.Registration") },
    { id: "tc-requirements", label: t("page.term.MembershipRequirements") },
    { id: "tc-code", label: t("page.term.Code") },
    { id: "tc-privacy", label: t("page.term.Privacy") },
    { id: "tc-ip", label: t("page.term.Intellectual") },
  ];

  return (
    <LegalPage
      id="terms-and-conditions"
      titleTestId="Terms & Conditions"
      title={t("page.term.TermsConditions")}
      toc={toc}
    >
      <LegalSection id="tc-use" title={t("page.term.Use")}>
        <p>{t("page.term.should")}</p>
      </LegalSection>

      <LegalSection id="tc-membership" title={t("page.term.Membership")}>
        <p>{t("page.term.qualify")}</p>
        <p>{t("page.term.voluntary")}</p>
      </LegalSection>

      <LegalSection id="tc-registration" title={t("page.term.Registration")}>
        <p>{t("page.term.apply")}</p>
        <p>{t("page.term.agree")}</p>
        <LegalList
          items={[
            t("page.term.register"),
            t("page.term.least"),
            t("page.term.provide"),
            t("page.term.become"),
            t("page.term.promptly"),
          ]}
        />
        <p>{t("page.term.terminate")}</p>
        <p>
          {t("page.term.sending")}{" "}
          <a className={legalLinkClass} href={"mailto:" + "support@Zampliasurveys.com"}>
            {Constant.TERM_SUPPORT}
          </a>{" "}
          {t("page.term.requesting")}
        </p>
      </LegalSection>

      <LegalSection id="tc-requirements" title={t("page.term.MembershipRequirements")}>
        <p>{t("page.term.choose")}</p>
        <p>{t("page.term.agreeto")}</p>
        <p>{t("page.term.acknowledge")}</p>
      </LegalSection>

      <LegalSection id="tc-code" title={t("page.term.Code")}>
        <p>{t("page.term.obligations")}</p>
        <LegalList
          ordered
          items={[
            t("page.term.directly"),
            t("page.term.communication"),
            t("page.term.website"),
            t("page.term.confidential"),
            t("page.term.accessible"),
            t("page.term.information"),
            t("page.term.notify"),
            t("page.term.comply"),
            t("page.term.other"),
            t("page.term.Market"),
          ]}
        />
      </LegalSection>

      <LegalSection id="tc-privacy" title={t("page.term.Privacy")}>
        <p>{t("page.term.Protection")}</p>
      </LegalSection>

      <LegalSection id="tc-ip" title={t("page.term.Intellectual")}>
        <p>{t("page.term.rights")}</p>
        <p>{t("page.term.Site")}</p>
      </LegalSection>
    </LegalPage>
  );
}
